//packages
import React from 'react';
import { Router, Route, Switch } from 'react-router-dom';
// import ThemeProvider as MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import { MuiThemeProvider } from '@material-ui/core/styles';

import { createMuiTheme } from '@material-ui/core/styles';
import { history } from './vibe/components/utilities/MainUtils/hist';
//components
import Component404 from './views/pages/404'
import PrivateRoute from './PrivateRoute'
//style
import './vibe/scss/styles.scss';
import './customStyles/datePicker.css'
import './customStyles/uploader.css'
//redux
import { Provider } from 'react-redux'
import configureStore from './redux/configureStore'

import LandingPage from './views/pages/LandingPage/LandingPage'
import Register from './views/pages/Register/Register';

// error dialogue
import ErrorDialogue from './views/pages/Register/errorDialogue/ErrorDialogue'
//redux
import jwt_decode from 'jwt-decode';
import setAuthToken from './vibe/components/utilities/MainUtils/setAuthToken'
import { logoutUser } from './redux/actions/auth.action'
import { setCatalogs, getCatalogs } from './redux/actions/catalog.action'

import ReactGA from 'react-ga';
ReactGA.initialize('UA-157577023-1');
ReactGA.pageview(window.location.pathname + window.location.search);

const store = configureStore()

store.subscribe(() => {
  // console.log(store.getState())
});

const theme = createMuiTheme({
  typography: {
    fontFamily: [
      'proba_pro_regular',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
  palette: {
    primary: {
      main: '#2D5CA6'
    },
    secondary: {
      main: '#79ac3d'
    }
  },
  overrides: {
    MuiModal: {
      root: {
        zIndex: '1300 !important'
      }
    },
    MuiButton: {
      root: {
        borderRadius: '0px',
        color: '#fff'
      }
    },
  // MuiPaper:{
  //   root: {
  //     borderRadius: '0px !important',

  //   }
  // },
    MuiCard:{
      root: {
        overflow: 'visible',
  
      }
    }
  
  }
 })


 if (localStorage.catalogs) {
  const catalogs = JSON.parse(localStorage.catalogs)
  store.dispatch(setCatalogs(catalogs))
} else {
  store.dispatch(getCatalogs())
}

// if (localStorage.catalogs) {
//   props.setCatalogs(JSON.parse(localStorage.catalogs))
// } else {
  
// }

// if (!localStorage.meetingState) {
//   async function getMeetingState() {
//     try {
//       const response = await meetingState()
//       localStorage.setItem('meetingState', JSON.stringify(response.data));
//     } catch (error) {
//       localStorage.setItem('meetingState', []);
//     }
//   }

//   getMeetingState()
// }

// if (!localStorage.region) {
//   async function getUkraineRegion() {
//     try {
//       const response = await getRegion()
//       localStorage.setItem('region', JSON.stringify(response.data));
//     } catch (error) {
//       localStorage.setItem('region', []);
//     }
//   }

//   getUkraineRegion()
// }

 if (localStorage.jwtToken) {
  setAuthToken(localStorage.jwtToken);
  // Decode token and get user info and exp
    const decoded = jwt_decode(localStorage.jwtToken);

  const currentTime = Date.now() / 1000;
  //console.log(decoded.exp < currentTime)
  if (decoded.exp < currentTime) {
    // Logout user
    store.dispatch(logoutUser());
    // Redirect to login
    //window.location.href = '/login';
    history.push("/");
  }
 }

export default function App() {
  return (
    <Provider store={store}>
      <MuiThemeProvider theme={theme}>
        <Router history={history}>
          <Switch>
            <Route exact path="/" component={LandingPage}/>
            {/* <Route  path="/login-page" component={LoginPage}/> */}
            {/* <Route  path="/register" component={Register}/> */}
            <Route path="/error" component={ErrorDialogue} />
            <PrivateRoute component={Register}/>
            <Route component={Component404} />
          </Switch>
        </Router>
      </MuiThemeProvider>
    </Provider>
  );
}
